import CollegeInput from "./CollegeInput";
export default CollegeInput;
